import { Container } from 'src/components/common/Container'
import { Divider } from 'src/components/common/Divider'
import styled, { css } from 'styled-components'
import React from 'react'
import {
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body2_r14,
  Noto_DisPlay2_b24,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { Icon } from 'src/assets/svg/Icon'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import { CouponRefundPageProps } from 'src/pages/CouponRefundPage/index'
import { ReactHookFc } from 'src/components/common/ReactHookForm'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { useFormContext } from 'react-hook-form'
import { CouponRefundFormItemsType } from 'src/types/react-hook-form'
import { Roboto_num1_b24 } from 'src/styles/fonts/RobotoFonts'

const CouponRefundPageView = ({
  refundSubmitRequestHandler,
  registerAttribute,
  passCertRequest,
  userName,
}: CouponRefundPageProps) => {
  const { termsAgree, accountNumber, bankNum, name, telecomCertFile } = registerAttribute
  const {
    formState: { errors, isValid = {} },
    handleSubmit,
  } = useFormContext<CouponRefundFormItemsType>()

  const {
    telecomCertFile: { message: telecomCertFileErrMsg } = {},
    bankNum: { message: bankNumErrMsg } = {},
    accountNumber: { message: accountNumberErrMsg } = {},
    name: { message: nameErrMsg } = {},
  } = errors

  return (
    <S.CouponRefundPageContainer $option="flex_column" $row_gap="50px" $noPadding={!!userName}>
      {!userName && (
        <>
          <S.CouponRefundContentsStyle $option="flex_column">
            <Container $option="flex_row" $column_gap="10px">
              <S.CouponRefundStepNumber $text="1" $color="var(--black-90)" />
              <S.CouponRefundStepNumber $text="2" $color="var(--black-20)" />
            </Container>
            <S.CouponRefundNoticePrimary
              $fontStyle={Noto_DisPlay2_b24}
              $text="통신사 이용계약증명서"
            />
            <S.CouponRefundNoticeBg $option="flex_column">
              <S.CouponRefundNoticeDesc $fontStyle={Noto_body1_r16} $color="var(--black-50)">
                휴대폰쿠폰지갑에 가입된 휴대폰 번호의 ‘통신사 이용계약증명서’를 등록해주세요.
                (이용계약증명서 발급 방법은 가입하신 통신사에 문의하시기 바랍니다.)
              </S.CouponRefundNoticeDesc>
            </S.CouponRefundNoticeBg>
            <ReactHookFc.FileUploader
              {...telecomCertFile}
              style={S.CouponRefundFileUpLoaderWrap(telecomCertFileErrMsg)}
              bottomChildren={<FormErrorMsg $text={telecomCertFileErrMsg as string} />}
            />
            <S.PassCertButton onClick={() => passCertRequest(0)}>
              추가 서류 제출 없이 환불 신청하기
              <Icon.Arrow size="16" rotate="right" color="var(--brand-50)" />
            </S.PassCertButton>
          </S.CouponRefundContentsStyle>
          <Divider />
        </>
      )}
      <S.CouponRefundContentsStyle $option="flex_column">
        {!userName && (
          <Container $option="flex_row" $column_gap="10px">
            <S.CouponRefundStepNumber $text="1" $color="var(--black-20)" />
            <S.CouponRefundStepNumber $text="2" $color="var(--black-90)" />
          </Container>
        )}
        <S.CouponRefundNoticePrimary $fontStyle={Noto_DisPlay2_b24} $text="환불 계좌 정보" />
        <S.CouponRefundNoticeBg $option="flex_column">
          <S.CouponRefundNoticeDesc $fontStyle={Noto_body1_r16} $color="var(--black-50)">
            ※ 환불은 휴대폰쿠폰지갑에 가입된 명의자 본인 계좌로만 가능합니다. 가입자 본인 확인이
            어려울 경우 환불이 어려울 수 있습니다.
            {!userName && (
              <>
                <br />
                <br />※ 정보 도용 등으로 인한 고객 피해 발생 방지와 안전한 거래를 위하여 사용 중이신
                휴대폰번호의 이동통신사를 통해 확인 후 본인 명의의 계좌로 환불을 진행하고 있습니다.
              </>
            )}
          </S.CouponRefundNoticeDesc>
        </S.CouponRefundNoticeBg>
        <Container $option="flex_column" $row_gap="20px">
          <Container $option="flex_column">
            <ReactHookFc.Select
              {...bankNum}
              style={RefundFormItemsStyle(!bankNumErrMsg)}
              topChildren={
                <S.CouponRefundFormTitle $text="은행명">
                  <Icon.Arrow
                    size="16"
                    rotate="bottom"
                    color="var(--black-30)"
                    style={S.CouponRefundSelectArrow}
                  />
                </S.CouponRefundFormTitle>
              }
              bottomChildren={<FormErrorMsg $text={bankNumErrMsg} />}
            />
          </Container>
          <Container $option="flex_column">
            <ReactHookFc.Input
              {...accountNumber}
              style={RefundFormItemsStyle(!accountNumberErrMsg)}
              topChildren={<S.CouponRefundFormTitle $text="계좌번호" />}
              bottomChildren={<FormErrorMsg $text={accountNumberErrMsg} />}
            />
          </Container>
          <Container $option="flex_column">
            <ReactHookFc.Input
              {...name}
              style={RefundFormItemsStyle(!nameErrMsg)}
              topChildren={
                <Container $option="flex_column">
                  <S.CouponRefundFormTitle $text="예금주 이름" />
                  <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
                    사업자 계좌의 경우 전체 이름을 정확히 입력해주세요.
                  </Typography>
                </Container>
              }
              bottomChildren={<FormErrorMsg $text={nameErrMsg} />}
            />
          </Container>
          <Container $option="flex_row_space_between" $column_gap="8px">
            <ReactHookFc.CheckBox
              {...termsAgree}
              bottomChildren={
                <Container $option="flex_column" $row_gap="7px">
                  <Typography $fontStyle={Noto_body1_r16} $color={'var(--black-90)'}>
                    {termsAgree.labelValue}
                  </Typography>
                  <Container
                    $option="flex_row"
                    $style={RefundTermsDetailText}
                    onClick={termsAgree.labelOnClick}
                  >
                    <Typography $fontStyle={Noto_body2_b14} $color="var(--black-50)">
                      자세히 보기
                    </Typography>
                    <Icon.Arrow size="16" rotate="right" color="var(--black-50)" />
                  </Container>
                </Container>
              }
            />
          </Container>
        </Container>
      </S.CouponRefundContentsStyle>
      <S.RefundSubmitButtonWrap $option="flex_column">
        <Button
          option={ButtonOption3('active')}
          onClickFn={handleSubmit(refundSubmitRequestHandler)}
          disabled={!isValid}
        >
          제출하기
        </Button>
      </S.RefundSubmitButtonWrap>
    </S.CouponRefundPageContainer>
  )
}
export default CouponRefundPageView

const S = {
  CouponRefundPageContainer: styled(Container)<{ $noPadding: boolean }>`
    padding-top: ${({ $noPadding }) => ($noPadding ? 0 : 40)}px;
  `,
  CouponRefundContentsStyle: styled(Container)`
    padding: 0 20px;
  `,
  CouponRefundSelectArrow: {
    top: '43px',
    right: '16px',
  },
  CouponRefundFileUpLoaderWrap: (telecomCertFileErrMsg?: string) => css`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 58px;
    border-radius: 12px;
    background: ${!!telecomCertFileErrMsg ? '#feebeb' : 'var(--black-6)'};
    padding: 10px;
    gap: 10px;

    > button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 10px;
      width: fit-content;
      min-width: 102px;
      height: 38px;
      border-radius: 8px;
      border: 1px solid var(--black-10);
      background: var(--white);
      &:disabled {
        cursor: default;
      }
    }
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: right;
      gap: 10px;
      max-width: 500px;
      width: 100%;

      ${mediaMaxWidth('688')} {
        width: 64%;
      }
      ${mediaMaxWidth('320')} {
        width: 57%;
      }
      > span {
        ${Noto_body2_r14};
        ${ellip('line1')};
        text-align: right !important;
        color: var(--black-70);
      }
      > svg {
        min-width: 24px;
      }
    }
  `,
  PassCertButton: styled.button`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ${Noto_body2_b14};
    margin-top: 13px;
    gap: 2px;
    color: var(--brand-50);
  `,
  CouponRefundFormTitle: styled.span<{ $text: string }>`
    ${Noto_body2_m14};
    color: var(--black-50);
    display: flex;
    justify-content: space-between;
    > span {
      position: relative;
    }
    &:before {
      content: '${(props) => props.$text}';
    }
  `,
  CouponRefundNoticePrimary: styled(Typography)<{ $text?: string }>`
    margin-top: 14px;
    white-space: pre-wrap;
    display: flex;
    &:before {
      content: '${(props) => props.$text}';
    }
  `,
  CouponRefundNoticeDesc: styled(Typography)`
    white-space: pre-wrap;
  `,
  CouponRefundNoticeBg: styled(Container)`
    padding: 16px;
    background-color: var(--brand-5);
    margin: 20px auto;
    border-radius: 12px;
    justify-content: center;
  `,
  CouponRefundStepNumber: styled(Typography)<{ $text?: string }>`
    display: ${(props) => (!!props.$text ? 'flex' : 'none')};
    ${Roboto_num1_b24};
    &:before {
      content: '${(props) => props.$text}';
    }
  `,
  RefundSubmitButtonWrap: styled(Container)`
    border-top: 1px solid var(--black-4);
    padding: 10px;
  `,
}

const RefundFormItemsStyle = (valid: boolean) => css`
  width: 100%;
  height: 48px;
  border-radius: 12px;
  padding: 12px 16px;
  background-color: var(--white);
  border: 1px solid var(--black-20);
  ${Noto_body1_r16};

  ${!valid &&
  css`
    background-color: var(--black-2);
    border: 1px solid var(--red-50);
  `}

  &::placeholder {
    color: var(--black-40);
  }
`

const RefundTermsDetailText = css`
  align-items: center;
`

const FormErrorMsg = styled.span<{ $text?: string }>`
  display: ${(props) => (!!props.$text ? 'flex' : 'none')};
  ${Noto_body2_r14};
  color: var(--red-50);
  &:before {
    content: '${(props) => props.$text}';
  }
`
